import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import "./RetailInvestors.css";
import SecondaryNavbar from "../SecondaryNavbar/SecondaryNavbar";
export default function RetailInvestors() {
  const navData = [
    { to: "/RetailInvestors", link: "Retail Investors" },
    { to: "/InstitutionalInvestors", link: "Institutional Investors" },
  ];
  return (
    <>
      <SecondaryNavbar props={navData} />
      <UpdatesBanner
        className="retailInvestorBanner text-white"
        bannerText="Retail Investor"
      />
    </>
  );
}
